import PropTypes from "prop-types";

export default PropTypes.shape({
  avatar: PropTypes.string,
  company: PropTypes.string,
  id: PropTypes.number,
  other_user_name: PropTypes.string,
});
